<template>
  <footer class="has-bg-dark">
    <div class="container has-text-white has-text-centered-mobile">
      <div class="column is-9 is-offset-3 is-paddingless-left is-paddingless-right">
        <div class="columns">
          <div v-if="profil != null" class="column is-4 is-3-widescreen">
            <ul>
              <li class="is-padding-xsmall is-paddingless-top">
                <a href="#" class="has-text-white">
                  Guide d'utilisation
                </a>
              </li>
              <li class="is-padding-xsmall">
                <a href="#" class="has-text-white">Tutoriel vidéo</a>
              </li>
              <li class="is-padding-xsmall">
                <a href="#" class="has-text-white">Accès support technique</a>
              </li>
            </ul>
          </div>
          <div
            v-if="profil != null"
            class="columns column has-text-centered-touch is-block-touch is-4-fullhd is-5-widescreen is-4 is-paddingless"
          >
            <div class="column is-narrow is-full-touch is-paddingless-left is-paddingless-right is-paddingless-bottom">
              <i class="far fa-comments-alt fa-5x"></i>
            </div>
            <div class="column is-full-touch content">
              <h3 class="has-text-white is-margin-bottom-xsmall">
                Consulter notre FAQ
              </h3>
              <p>
                Nos réponses aux questions les plus fréquentes
              </p>
              <p>
                <a href="#" class="has-text-success">
                  Consultez maintenant
                </a>
              </p>
            </div>
          </div>
          <div
            v-if="profil != null"
            class="columns column has-text-centered-touch is-block-touch is-4 is-offset-1-fullhd is-paddingless"
          >
            <div class="column is-narrow is-full-touch is-paddingless-left is-paddingless-right is-paddingless-bottom">
              <i class="far fa-user-circle fa-5x"></i>
            </div>
            <div class="column is-full-touch content">
              <h3 class="has-text-white is-margin-bottom-xsmall">
                Une question ?
              </h3>
              <p>Un expert à vos côtés</p>
              <p>
                <a href="#" class="has-text-success">
                  Contactez-nous
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="column has-text-centered-mobile has-text-right-tablet">
        <ul class="has-text-white is-size-7 menu-footer">
          <li class="is-inline-block">
            Copyright © 2021 <a href="https://www.okgo.fr/" style="color : white;" target="_blank">Okgo</a>.
            All rights reserved &nbsp;
          </li>
          <li v-for="footerMenuEntry in footerMenuEntries" :key="footerMenuEntry.slug" class="is-inline-block">
            <router-link :to="{ name: 'Topic', params: {topicId: footerMenuEntry.slug}}" class="has-text-white">
              {{ footerMenuEntry.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

  </footer>
</template>
<script>
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'

  export default {
    name: 'MyFooter',
    computed: {
      ...mapState(['profil']),
      ...mapGetters(['footerMenuEntries']),
    }
  }
</script>



<style scoped>

</style>
